<div id="api-token">
  <div>
    <div class="main_profile">
      <div class="modal-header switch_header">
        <ng-container>
          <div class="col-lg-12 col-xl-12 col-12">
            <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
              API KEYS
            </h3>
          </div>
        </ng-container>
      </div>
      <div class="modal-body bg-white body-content" style="overflow: auto;">
        <ng-container>
          <div class=" details col-lg-12 col-md-12 px-sm-5 px-0">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">ID:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.item.id }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Client ID:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.item.client_id }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Client secret:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="breakword">{{ data.item.client_secret }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Use count:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{data.item.use_count? (data.item.use_count | number) : '----'}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Last used:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{data.item.last_used ?( data.item.last_used | dateFormat: 'MM/dd/yyyy') : '----'}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Expiry date :</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{data.item.expires_at ?( data.item.expires_at | dateFormat: 'MM/dd/yyyy') : '----'}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">API/Bearer Token :</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6 secret-key">
                <div id="secret">{{ data.token }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="p-0">
        <div class="dropdown-footer">
          <div class="row justify-content-around">
              <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()">
                Cancel
              </button>
              <button class="btn btn-default lg-btn ok-btn" (click)="copy( data.token )" id="myTooltip">
                Copy
              </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
